import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // expand accordion item visibility via :checked css property
    // when its id is in the url #anchor
    const rawHash = window.location.hash || "";
    const id = rawHash.startsWith("#") ? rawHash.slice(1) : rawHash;
    if (id) {
      const el = document.querySelector("#" + id + " input.toggler");
      if (el) {
        console.log("clicking " + id);
        el.checked = true;
      }
      // dispatch a tab click event if the accordion item is nested
      // in a tab control
      const el_tab = document.querySelector(
        "input[data-action='tabs#toggle']:has(+ div .accordion #" + id + ")",
      );
      if (el_tab) {
        window.addEventListener("DOMContentLoaded", () => {
          el_tab.click();
        });
      }
    }
    // add accordion#expand action to all anchor links
    const internalLinks = document.querySelectorAll(
      "div.accordion .accordion-body a[href*='#']:not(.btn)",
    );
    if (internalLinks) {
      for (const internalLink of internalLinks) {
        internalLink.dataset.action = "accordion#expand";
      }
    }
  }
  // expand the target accordion item when its anchor link is clicked
  expand(event) {
    const id = event.currentTarget.getAttribute("href");
    const item = document.querySelector(id + " input.toggler");
    if (item) {
      item.click();
    }
  }
  // expand or collapse all accordion items
  toggle_all(event) {
    const button = event.currentTarget;
    const expand_label = event.currentTarget.querySelector(
      '[data-label-variant="expand"]',
    );
    const collapse_label = event.currentTarget.querySelector(
      '[data-label-variant="collapse"]',
    );
    const inputTargets = document.querySelectorAll(
      `#${event.params.id} label.accordion-button + input`,
    );
    for (const inputTarget of inputTargets) {
      if (
        (event.params.expand && !inputTarget.checked) ||
        (!event.params.expand && inputTarget.checked)
      ) {
        inputTarget.click();
      }
    }
    // toggle button action parameter and label
    button.dataset.accordionExpandParam = !event.params.expand;
    expand_label.classList.toggle("d-none");
    collapse_label.classList.toggle("d-none");
  }
}
